import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";

import AddInventoryComp from "./AddInventoryComp";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import { convertToLowestUnit, ExportAvailableInCSVForReports, formatUnitsForReport, GetUpdatedDelivered } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import BatchWithdrawModal from "../../../../components/BatchWithdrawModal";
import preloader from "../../../../helpers/preloader";
import { findEarliestExpiringBatches } from "../../../../helpers/batchWithdrawl";
import ExpiryChangePopup from "../../../../components/ExpiryChangeModal";

const ViewInventory = (props) => {
  const { SearchBar } = Search;
  useEffect(() => {
    loadProducts();
  }, []);
  const is_manual_entry_allowed = localStorage.getItem("is_manual_entry_allowed") == "true";

  const [allProducts, setAllProducts] = useState([]);
  const loadProducts = async () => {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "products/getall";
    const response = await postSubmitForm(url, {});
    if (response && response.status === 1) {
      preloader(false)
      response.data.map((prod) => (prod.quantity_to_add = ""));
      setAllProducts(response.data);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
  };

  const [transactionsModal, setTransactionsModal] = useState();
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectedProduct_Transactions, setSelectedProduct_Transactions] =
    useState([]);
    
  const handleViewDetailsClick = async (row) => {
    let url =
      process.env.REACT_APP_BASEURL + "storeproductinventories/get_by_product_id";
    const response = await postSubmitForm(url, { product_id: row._id });
    if (response && response.status === 1) {
      setSelectedProduct_Transactions(response.data);
      setSelectedProduct(row);
      setTransactionsModal(true);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [selectedProductToAdd, setSelectedProductToAdd] = useState();
  function editFormatter(cell, row) {
    return (
      <>
        <span className="text-info mr-2">
          <i
            className="mdi mdi-text-box-search font-size-15"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleViewDetailsClick(row);
            }}
          ></i>
        </span>
        <span style={{ display: is_manual_entry_allowed ? 'inline' : 'none' }}>
          <i
            className="mdi mdi-cart-plus font-size-15"
            title="Add Opening Inventory"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedProductToAdd(row);
              setAddInventoryModal(!addInventoryModal);
            }}
          ></i>
        </span>
      </>
    );
  }
  const columns = [
    {
      dataField: "_id",
      hidden: true,
      editable: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
      editable: false,
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      editable: false,
    },
    {
      dataField: "section",
      text: props.t("Section"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "available",
      text: props.t("Available"),
      sort: true,
      editable:false,
      formatter: (cell, row) => {
        let threshold = convertToLowestUnit(row?.unit_levels,[{unit:row?.unit_for_threshold,value:row?.threshold}]);
        let totalAvailable =   convertToLowestUnit(row?.unit_levels,row?.available)
        if (row.available?.length > 0) {
          if (totalAvailable<=threshold) {
            return (
              <span
                style={{ whiteSpace: 'normal', display: 'inline-block', maxWidth: '100%' }}
                className="font-size-12 badge-soft-danger badge badge-danger badge-pill mr-1 mb-1">
                {formatUnitsForReport(row.available)}
              </span>
            );
          } else {
            return formatUnitsForReport(row.available);
          }
        } else {
          return null;
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      formatter: (cell, row) => {
        return (
          row.threshold + " " + row.unit_for_threshold 
        )
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "expiry_days",
      text: props.t("Expires in"),
      formatter: (cell, row) => {
        return row.expiry_days > 1
          ? row.expiry_days + " Days"
          : row.expiry_days + " Day";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
  ];
  function checkValues(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].value > 0) {
        return true;
      }
    }
    return false;
  }
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const [selectedBatch, setSelectedBatch] = useState();
  const [withdrawModal, setWithrdrawModal] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const handleWithdrawClicked = async (quantity) => {
    if(quantity.length<=0){
      showNotification("Please enter a valid quantity ","Warning")
      return
    }
    let convertedQuantity = GetUpdatedDelivered(quantity,selectedProduct.unit_levels)
    const isInvalidTransfer = convertedQuantity.every(item => item.value == 0 );
    if (isInvalidTransfer) {
      showNotification("Can't transfer product with value 0 and checked", "Warning");
      return;
    }
    const object = {
      branchproductinventory_id: selectedBatch._id,
      quantity: convertedQuantity.map(({unit,value})=>({unit,value})),
    };
    setIsLoading(true)
    let url = process.env.REACT_APP_BASEURL + "branchproductinventories/withdraw";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      setIsLoading(false)
      showNotification(response.message, "Success");
      loadProducts();
      setSelectedBatch()
      setTransactionsModal(!transactionsModal);
      setWithrdrawModal(!withdrawModal);
      return true
    } else {
      setIsLoading(false)
      showNotification(response.message, "Error");
      return false
    }
  };
  const [discardWasteModal, setDiscardWasteModal] = useState();
  const handleDiscardAsWaste = async (quantity) => {
    try {
      if(quantity.length<=0){
        showNotification("Please enter a valid quantity ","Warning")
        return
      }
      let convertedQuantity = GetUpdatedDelivered(quantity,selectedProduct.unit_levels)
      const isInvalidTransfer = convertedQuantity.every(item => item.value == 0 );
      if (isInvalidTransfer) {
        showNotification("Cannot discard product with value 0 and checked", "Warning");
        return;
      }
      const object = {
        branchproductinventory_id: selectedBatch._id,
        quantity: convertedQuantity.map(({unit,value})=>({unit,value})),
      };
      setIsLoading(true)
      let url =  process.env.REACT_APP_BASEURL + "branchproductinventories/mark_wasted";
      const response = await postSubmitForm(url, object);
      if (response && response.status === 1) {
        showNotification(response.message, "Success");
        setTransactionsModal(!transactionsModal);
        setDiscardWasteModal(!discardWasteModal);
        loadProducts();
        setSelectedBatch()
        return true
      } else {
        showNotification(response.message, "Error");
        return false
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false)
    }
  };

  const [dateChangeModal, setDateChangeModal] = useState(false);
  const [selectedRowForDateChange, setSelectedRowForDateChange] = useState(null);
  const handleExpiryDateChange = async (newDate) => {
    try {
      if (!newDate) {
        showNotification("Please select a valid date", "Warning");
        return;
      }
      preloader(true);
      const url =
        process.env.REACT_APP_BASEURL +
        "storeproductinventories/update_expiry_date";
      const payload = {
        id: selectedRowForDateChange._id,
        batch: selectedRowForDateChange.batch,
        expiry_date: moment(newDate).format("YYYY-MM-DD"),
      };
      const response = await postSubmitForm(url, payload);
      if (response && response.status === 1) {
        showNotification("Expiry date updated successfully", "Success");
        handleViewDetailsClick(selectedProduct);
        setDateChangeModal(false);
        setSelectedRowForDateChange(null);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification("Error updating expiry date", "Error");
    } finally {
      preloader(false);
    }
  };
  const columns_transaction = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Quantity"),
      sort: true,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity && row.quantity)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },

    {
      dataField: "cost_price",
      text: props.t("Cost Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "selling_price",
      text: props.t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
   {
        text: props.t("Expiry Date"),
        sort: false,
        formatter: (cell, row) => {
          if (row.expiry_date) {
            return moment(row.expiry_date).format("DD/MM/YYYY HH:mm");
          } else {
            return (
              <>
                <span
                  className="text-info d-flex align-items-center justify-content-center"
                  style={{cursor:"pointer"}}
                  onClick={() => {
                    setSelectedRowForDateChange(row);
                    setDateChangeModal(true);
                  }}
                >
                  <i className="bx bxs-edit font-size-15" />
                </span>
              </>
            );
          }
        },
        headerStyle: (colum, colIndex) => {
          return { width: "8%" };
        },
      },
   {
         dataField: "",
         text: props.t("Entry Date"),
         sort: false,
         formatter: (cell, row) => {
           return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
         },
         headerStyle: (colum, colIndex) => {
           return { width: "8%" };
         },
       },
   
    {
      text: props.t("Withdraw"),
      formatter: (cell, row) => {
        // Finding earliest expiring batches
        const earliestBatches = findEarliestExpiringBatches(selectedProduct_Transactions || []);
        // Checking if current row is in earliest batches
        const isEarliestBatch = earliestBatches.some(
          batch => batch._id === row._id
        );
        // Check if the batch has quantity
        const hasQuantity = row.quantity.some(q => q.value > 0);
        const isDisabled = row.expiry_date && !(isEarliestBatch && hasQuantity);
        return (
          <span className={`text-info ${isDisabled ? 'text-muted' : ''}`}>
            <i
              className={`bx bx-download font-size-22 ${isDisabled ? 'text-secondary' : ''}`}
              title="Withdraw"
              style={{
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                opacity: isDisabled ? 0.5 : 1
              }}
              onClick={() => {
                if(!isDisabled){
                  setSelectedBatch(row);
                  setWithrdrawModal(!withdrawModal);
                }
              }}
            ></i>
          </span>
      )},
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      text: props.t("Mark Wasted"),
      formatter: (cell, row) => {
        return checkValues(row.quantity) ? (

          <span className="text-info">
            <i
              className="bx bxs-trash font-size-22"
              title="Move to Waste"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedBatch(row);
                setDiscardWasteModal(!withdrawModal);
              }}
            ></i>
          </span>
        ) : (
          <span className="text-info">Out of stock</span>
        );
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];
  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value:
          selectedProduct_Transactions && selectedProduct_Transactions.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  const [addInventoryModal, setAddInventoryModal] = useState(false);

  const handleClosePopup = async () => {
    setAddInventoryModal(!addInventoryModal);
  };

  const handleDownload = async () => {
    const fileName = "view_inventory";
    const exportType = "xls";

    let data_to_export = allProducts;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          name: v.name,
          section: v.section,
          category: v.category,
          available: ExportAvailableInCSVForReports(v.available),
          threshold: v.threshold + " "+v.unit_for_threshold,
          expiry_days: v.expiry_days,
          is_premium_product:v.is_premium_product?"Yes":"No"
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Finished Products")}
            breadcrumbItem2={props.t("View Inventory")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("View Inventory")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all products in your inventory here")}
                  </CardSubtitle>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"  "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allProducts && allProducts}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <CardTitle>View Inventory</CardTitle>
                            </Col>
                            <Col lg={4} className="text-right">
                              {/* <button
                              className="btn-sm btn btn-info"
                              onClick={() => {
                                setAddInventoryModal(!addInventoryModal);
                              }}
                            >
                              Add Finished Product
                            </button> */}
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                            cellEdit={cellEditFactory({
                              mode: "click",
                              blurToSave: true,
                              afterSaveCell: async (
                                oldValue,
                                newValue,
                                row,
                                column
                              ) => {
                                if (
                                  +newValue < 0 ||
                                  (isNaN(newValue) && !isFinite(newValue))
                                ) {
                                  let arr = [...allProducts];
                                  for (let i = 0; i < arr.length; i++) {
                                    if (arr[i]._id === row._id) {
                                      arr[i].quantity_to_add = oldValue;
                                      break;
                                    }
                                  }
                                  setAllProducts(arr);
                                  showNotification(
                                    "Only positive numbers allowed.",
                                    "Error"
                                  );
                                } else if (+newValue === 0) {
                                  let arr = [...allProducts];
                                  for (let i = 0; i < arr.length; i++) {
                                    if (arr[i]._id === row._id) {
                                      arr[i].quantity_to_add = oldValue;
                                      break;
                                    }
                                  }
                                  setAllProducts(arr);
                                } else if (newValue !== "") {
                                  let url =
                                    process.env.REACT_APP_BASEURL +
                                    "productinventories/insert";
                                  let data_to_send = {};

                                  data_to_send.product_id = row._id;
                                  data_to_send.quantity = newValue;
                                  data_to_send.cost_price = row.cost_price;
                                  data_to_send.selling_price =
                                    row.selling_price;
                                  data_to_send.remarks = "";
                                  const response = await postSubmitForm(
                                    url,
                                    data_to_send
                                  );
                                  if (response && response.status === 1) {
                                    showNotification(
                                      response.message,
                                      "Success"
                                    );
                                    loadProducts();
                                  } else {
                                    showNotification(response.message, "Error");
                                  }
                                }
                              },
                            })}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={transactionsModal}
                    toggle={() => setTransactionsModal(!transactionsModal)}
                  >
                    <ModalHeader
                      toggle={() => setTransactionsModal(!transactionsModal)}
                    >
                      Product Name: {selectedProduct && selectedProduct.name}
                    </ModalHeader>
                    <ModalBody>
                      {selectedProduct && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedProduct_Transactions &&
                                          selectedProduct_Transactions
                                        }
                                        columns={columns_transaction}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              pagination={paginationFactory(
                                                pagination_options
                                              )}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={addInventoryModal}
                    toggle={() => setAddInventoryModal(!addInventoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setAddInventoryModal(!addInventoryModal)}
                    >
                      Add Finished Product
                    </ModalHeader>
                    <ModalBody>
                      <AddInventoryComp
                        isRefreshData={true}
                        refreshData={loadProducts}
                        selectedProduct={selectedProductToAdd}
                        handleClosePopup={handleClosePopup}
                        reset={true}
                      />
                    </ModalBody>
                  </Modal>

                   {/* ---Withdraw inventory start--- */}
                   <BatchWithdrawModal
                    isOpen={withdrawModal}
                    toggle={() => {setWithrdrawModal(false);setSelectedBatch()}}
                    onSubmit={handleWithdrawClicked}
                    item={selectedProduct}
                    isLoading={isLoading}
                    checkLimitFor={"batch"}
                    selectedBatch={selectedBatch}
                  />
                   {/* ---Withdraw inventory end--- */}

                   {/* ---Waste Modal Start--- */}
                  <BatchWithdrawModal
                    isOpen={discardWasteModal}
                    toggle={()=>{setDiscardWasteModal(false);setSelectedBatch()}}
                    onSubmit={handleDiscardAsWaste}
                    item={selectedProduct}
                    isLoading={isLoading}
                    checkLimitFor={"batch"}
                    selectedBatch={selectedBatch}
                  />
                 
                   {/* ---Waste Modal End--- */}

                  {/* ---Expiry Date Modal Start--- */}
                  <ExpiryChangePopup
                    isOpen={dateChangeModal}
                    toggle={() => {
                      setDateChangeModal(false);
                      setSelectedRowForDateChange(null);
                    }}
                    onSubmit={handleExpiryDateChange}
                    initialDate={selectedRowForDateChange?.expiry_date}
                    title="Change Expiry Date"
                  />
                  {/* ---Expiry Date Modal End--- */}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventory))
);
